import React, { FunctionComponent } from 'react'

import { ICustomer } from '../../../../../Customer/interfaces/ICustomer'

import { ProfileAvatar, Avatar } from './style'

interface IProps {
  customer: ICustomer
}

export const CustomerAvatar: FunctionComponent<IProps> = ({ customer }) => {
  const { customerName, customerLastName, customerAvatar } = customer

  const customerInitials = [customerName[0], customerLastName[0]]

  if (customerAvatar) {
    return (
      <ProfileAvatar
        src={customerAvatar}
        alt="User avatar image"
        // sx={{
        //   height: ['20%', '25%', '35%'],
        //   aspectRatio: '1/1',
        // }}
      />
    )
  }
  return (
    <Avatar
      className="avatar"
      // sx={{
      //   fontSize: ['25px', '25px', '35px'],
      //   aspectRatio: '1/1',
      // }}
    >
      {customerInitials}
    </Avatar>
  )
}
